
let initilized = false;

function load(key) {
	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    ga('create', key, 'auto');
}

export default {
	init() {
	    if(vidbaby && vidbaby.config && vidbaby.config.env && typeof vidbaby.config.env.googleAnalytics !== 'undefined' && !initilized) {
	        load(vidbaby.config.env.googleAnalytics);

	        vidbaby.$(document).on('na-ask.vidbaby', (event, payload) => {
	        	if(typeof payload === 'object') {
	        		if(payload instanceof Array) {
	                    payload.forEach(p => {
	                    	if(typeof payload === 'object') {
	                        	ga('send', 'event', 'Avatar', p.origin || 'Question', p.text);
	                        } else {
	                        	ga('send', 'event', 'Avatar', 'Question', p);
	                        }
	                    });
	                } else {
		        		ga('send', 'event', 'Avatar', payload.origin || 'Question', payload.text);
		        	}
	        	} else {
	        		ga('send', 'event', 'Avatar', 'Question', payload);
	        	}
	        });

	        vidbaby.$(document).on('na-response.vidbaby', (event, payload) => {
	        	ga('send', 'event', 'Avatar', 'Response', payload.answer);
	        });

	        vidbaby.$(document).on('na-extractedEntity.vidbaby', (event, data) => {
				if(data.searchTerm) {
					ga('send', 'event', 'Avatar', 'Search', typeof data.searchTerm === 'object' && data.searchTerm instanceof Array ? data.searchTerm.join(' ') : data.searchTerm);
				}
			});

	        initilized = true;
	    }
	}
}